import { forwardRef } from 'react';
import { createPortal } from 'react-dom';
import FocusLock from 'react-focus-lock';
import Layer from '../../Layer';
import { StyledDrawerList } from './styled';
import { useDrawerContext } from '../../../contexts/drawer';

const DrawerList = forwardRef((props, ref) => {
  const { isOpen, closeDrawer, listProps } = useDrawerContext();

  if (isOpen) {
    return createPortal(
      <FocusLock returnFocus autoFocus>
        <Layer onClose={closeDrawer}>
          <StyledDrawerList {...listProps(ref, props)} />
        </Layer>
      </FocusLock>,
      document.body
    );
  }

  return null;
});

export default DrawerList;
